import { useContext } from "react";
import { Badge as ModusBadge } from "@trimble/modus-cmx";
import { FeatureFlagContext } from "@/context/FeatureFlags/FeatureFlagContext";
import { UiFeatureFlagNames } from "@/gql/graphql";

export default function Badge({
  variant,
  ...restProps
}: React.ComponentProps<typeof ModusBadge>) {
  // Read context directly so badges still render in tests without FeatureFlagProvider.
  const featureFlags = useContext(FeatureFlagContext);
  const isUxUpdateEnabled =
    featureFlags?.canUseFeatureFlag(UiFeatureFlagNames.UxUpdate) ?? false;

  return (
    <ModusBadge
      {...restProps}
      variant={isUxUpdateEnabled ? "counter" : variant}
    />
  );
}
